import './report-list.scss'

import { defineComponent } from 'vue'

import { SortFilter } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { SearchHeader } from '@skinsoft/search/src/search-header'
import { ReportFeaturedList } from '@skinsoft/ui'

declare const config
const CONDITION_REPORTS_SORTING_ENTITY_FIELDS: SortFilter[] = config.conditionReportsSortingEntityFields
const OFFLINE_CONDITION_REPORTS_SORTING_ENTITY_FIELDS: SortFilter[] = config.offlineConditionReportsSortingEntityFields

export const ReportList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sReportFeaturedList: ReportFeaturedList,
        sSearchHeader: SearchHeader
    },
    props: ['listState', 'titleI18NKey', 'targetRouteName', 'titleClickAction'],
    template: require('./report-list.html'),
    data() {
        return {
            nbReports: "",
            sortingEntityFields: [] as any[],
        }
    },
    mounted() {
        this.$on('nb-fetched-reports-topic', (message) => {
            this.nbReports = this.$t('listReportScreen.nbResults', { nbResults: message.nbReports }) as string;
        })
        this.updateSortingFields()

        window.addEventListener('online', this.updateSortingFields)
        window.addEventListener('offline', this.updateSortingFields)
    },
    methods: {
        updateSortingFields() {
            if(window.navigator.onLine) {
                this.sortingEntityFields = CONDITION_REPORTS_SORTING_ENTITY_FIELDS
            } else {
                this.sortingEntityFields = OFFLINE_CONDITION_REPORTS_SORTING_ENTITY_FIELDS
            }
        },
    },
})
